// extracted by mini-css-extract-plugin
export default {"value":"Summary_value__6wuiD","wrapper":"Summary_wrapper__9z1s3"};